import { Link, NavLink, Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { Carregando } from "./ui";

export function Rodape() {
  return <footer className="app-footer no-print">Programa desenvolvido por Wladmir Vieira · © 2026</footer>;
}

export function Topbar({ children }: { children?: React.ReactNode }) {
  return (
    <div className="topbar no-print">
      <Link to="/" className="brand">
        <span className="dot" /> Diário de Obra
      </Link>
      {children}
    </div>
  );
}

/** Estrutura das páginas autenticadas (≙ base.html). */
export function Layout() {
  const { usuario, carregando, sair } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  if (carregando) {
    return (
      <div className="container">
        <Carregando />
      </div>
    );
  }
  if (!usuario) {
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  }

  return (
    <>
      <Topbar>
        <nav>
          <NavLink to="/" end>
            Diários
          </NavLink>
          {usuario.papel === "admin" && <NavLink to="/usuarios">Usuários</NavLink>}
        </nav>
        <div className="conta">
          <span className="note" style={{ color: "#dce8f7" }}>
            {usuario.nome}{" "}
            {usuario.papel === "admin" ? (
              <span className="badge badge-orange">admin</span>
            ) : usuario.pode_editar ? (
              <span className="badge badge-green">editor</span>
            ) : (
              <span className="badge badge-muted">somente leitura</span>
            )}
          </span>
          <Link to="/conta/senha" className="note" style={{ color: "#dce8f7" }}>
            Trocar senha
          </Link>
          <button
            type="button"
            className="btn-ghost"
            style={{ padding: "5px 12px", fontSize: "0.8rem" }}
            onClick={async () => {
              await sair();
              navigate("/login", { replace: true });
            }}
          >
            Sair
          </button>
        </div>
      </Topbar>
      <div className="container">
        <Outlet />
      </div>
      <Rodape />
    </>
  );
}

/** Rotas só do administrador (a API também bloqueia). */
export function RotaAdmin() {
  const { usuario } = useAuth();
  if (usuario?.papel !== "admin") return <p className="note">Acesso restrito ao administrador.</p>;
  return <Outlet />;
}

/** Páginas de impressão: exigem sessão, mas sem topbar/rodapé. */
export function LayoutSemMoldura() {
  const { usuario, carregando } = useAuth();
  const location = useLocation();
  if (carregando) return <Carregando />;
  if (!usuario) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  return <Outlet />;
}
